import { api } from './client';

export interface OidcProviderPublicSummary {
  slug: string;
  display_name: string;
}
export interface OidcProviderSummary extends OidcProviderPublicSummary {
  id: string;
  issuer_url: string;
  client_id: string;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}
export interface CreateOidcProviderDto {
  slug: string;
  display_name: string;
  issuer_url: string;
  client_id: string;
  client_secret: string;
}
export interface UpdateOidcProviderDto {
  display_name?: string;
  issuer_url?: string;
  client_id?: string;
  client_secret?: string;
}

export const oidcApi = {
  listPublic: () =>
    api.get<OidcProviderPublicSummary[]>('/auth/oidc/providers').then((r) => r.data),

  // Admin
  list: () =>
    api.get<{ items: OidcProviderSummary[] }>('/admin/oidc-providers').then((r) => r.data.items),
  create: (dto: CreateOidcProviderDto) =>
    api.post<OidcProviderSummary>('/admin/oidc-providers', dto).then((r) => r.data),
  update: (id: string, dto: UpdateOidcProviderDto) =>
    api.patch<OidcProviderSummary>(`/admin/oidc-providers/${id}`, dto).then((r) => r.data),
  enable: (id: string) => api.post(`/admin/oidc-providers/${id}/enable`).then(() => undefined),
  disable: (id: string) => api.post(`/admin/oidc-providers/${id}/disable`).then(() => undefined),
  remove: (id: string) => api.delete(`/admin/oidc-providers/${id}`).then(() => undefined),
};
